(() => {
  if (customElements.get('milanis-quiz')) return;
  customElements.define('milanis-quiz', class extends HTMLElement {
    connectedCallback() {
      this.timer = setTimeout(() => this.init(), 0);
    }
    init() {
      this.abort?.abort();
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.questions = [...this.querySelectorAll('[data-question]')].filter(q => q.querySelector('input[type=radio]'));
      this.results = [...this.querySelectorAll('[data-result]')];
      this.index = 0;
      this.storageKey = 'milanis-quiz:' + this.dataset.section;
      const on = (el, event, handler) => el?.addEventListener(event, handler, opts);
      on(document, 'click', e => {
        const a = e.target.closest('a[href]');
        if (!a) return;
        const url = new URL(a.href, location.href);
        if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#milanis-quiz') {
          e.preventDefault(); this.open(a);
        }
      });
      on(this.querySelector('[data-quiz-preview]'), 'click', e => this.open(e.currentTarget));
      on(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', e => { if (e.target === this.dialog) {
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
      }});
      on(this.dialog, 'close', () => this.unlock());
      on(this.querySelector('[data-start]'), 'click', () => this.showQuestion(0));
      on(this.querySelector('[data-name]'), 'keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); this.showQuestion(0); }
      });
      on(this.querySelector('[data-back]'), 'click', () => {
        if (this.index === 0) this.screen('intro'); else this.showQuestion(this.index - 1);
      });
      on(this.querySelector('[data-next]'), 'click', () => {
        const question = this.questions[this.index];
        if (!question?.querySelector('input:checked')) {
          this.querySelector('[data-validation]').textContent = this.dataset.error;
          question?.querySelector('input')?.focus(); return;
        }
        if (this.index + 1 < this.questions.length) this.showQuestion(this.index + 1);
        else this.showResult();
      });
      on(this, 'change', e => {
        if (e.target.matches('input[type=radio]')) this.querySelector('[data-validation]').textContent = '';
      });
      on(this.querySelector('[data-restart]'), 'click', () => {
        this.querySelectorAll('input[type=radio]').forEach(i => i.checked = false);
        this.index = 0; this.screen('intro');
      });
      const form = this.querySelector('.mq-form');
      on(form, 'submit', () => {
        // Native Shopify submit preserves its validation, anti-spam and consent handling.
        // Store only choices, not name or email, to restore the result after navigation.
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({
            time: Date.now(),
            choices: this.questions.map(q => ({id:q.dataset.question, value:q.querySelector('input:checked')?.value}))
          }));
        } catch (_) {}
      });
      on(document, 'shopify:section:select', e => {
        if (e.detail.sectionId === this.dataset.section) this.open();
      });
      on(document, 'shopify:section:deselect', e => {
        if (e.detail.sectionId === this.dataset.section && this.dialog.open) this.dialog.close();
      });
      on(document, 'shopify:block:select', e => {
        if (!this.contains(e.target)) return;
        this.open();
        const i = this.questions.findIndex(q => q.dataset.question === e.detail.blockId);
        if (i >= 0) this.showQuestion(i);
        else {
          const result = this.results.find(r => r.dataset.block === e.detail.blockId);
          if (result) this.showResult(result.dataset.result);
        }
      });
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(this.storageKey)); } catch (_) {}
      const returned = this.querySelector('[data-server-success], [data-server-errors]');
      const ownHash = form && location.hash === '#' + form.id;
      if (saved && Date.now() - saved.time < 1800000 && (returned || ownHash)) {
        for (const choice of saved.choices || []) {
          const q = this.questions.find(q => q.dataset.question === choice.id);
          const input = q && [...q.querySelectorAll('input')].find(i => i.value === choice.value);
          if (input) input.checked = true;
        }
        this.open(); this.showResult();
        this.querySelector('.mq-signup')?.scrollIntoView({block:'nearest'});
        try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
      } else if (location.hash === '#milanis-quiz') this.open();
    }
    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger || document.activeElement;
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.dialog.showModal();
      this.focusScreen();
    }
    unlock() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.oldOverflow;
      this.locked = false;
      if (this.trigger?.isConnected) this.trigger.focus();
    }
    screen(name) {
      this.querySelectorAll('[data-screen]').forEach(el => el.hidden = el.dataset.screen !== name);
      this.querySelector('.mq-body').scrollTop = 0;
      this.focusScreen();
    }
    focusScreen() {
      const screen = this.querySelector('[data-screen]:not([hidden])');
      const heading = screen?.querySelector('fieldset:not([hidden]) legend, article:not([hidden]) h3, h2');
      heading?.focus({preventScroll:true});
    }
    showQuestion(i) {
      if (!this.questions.length) { this.showResult(); return; }
      this.index = i;
      this.questions.forEach((q,n) => q.hidden = n !== i);
      const progress = this.querySelector('[data-progress]');
      progress.max = this.questions.length; progress.value = i + 1;
      this.querySelector('[data-progress-text]').textContent = (i + 1) + ' / ' + this.questions.length;
      this.querySelector('[data-validation]').textContent = '';
      const next = this.querySelector('[data-next]');
      next.textContent = i === this.questions.length - 1 ? next.dataset.resultLabel : next.dataset.nextLabel;
      this.screen('questions');
    }
    winner() {
      const scores = {minimal:0, statement:0, classic:0, romantic:0};
      const order = [];
      for (const q of this.questions) {
        const style = q.querySelector('input:checked')?.dataset.style;
        if (Object.hasOwn(scores, style)) {
          scores[style] += Number(q.dataset.weight) || 1;
          if (!order.includes(style)) order.push(style);
        }
      }
      // Highest score wins; ties follow the first matching answer.
      const available = [...new Set(this.results.map(r => r.dataset.result))];
      return [...order, 'classic', ...available].filter((v,i,a) => available.includes(v) && a.indexOf(v) === i)
        .sort((a,b) => scores[b] - scores[a])[0];
    }
    showResult(style) {
      const chosen = this.results.find(r => r.dataset.result === (style || this.winner())) || this.results[0];
      this.results.forEach(r => r.hidden = r !== chosen);
      const name = this.querySelector('[data-name]').value.trim();
      const greeting = this.querySelector('[data-greeting]');
      greeting.textContent = name; greeting.hidden = !name;
      this.screen('result');
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
    }
  });
})();

